import * as React from "react"
import ClickAwayListener from "react-click-away-listener"
import { Box, IconButton, Stack, Tooltip } from "@chakra-ui/react"
import { BsLayers } from "react-icons/bs"
import { LiaSatelliteSolid } from "react-icons/lia"
import { HiOutlineColorSwatch } from "react-icons/hi"
import { MdOutlineLightMode, MdOutlineDarkMode } from "react-icons/md"
import { useMapSettings } from "./providers/MapSettingsProvider"

const MapStyleControl: React.FC = () => {
  const [showOpts, setShowOpts] = React.useState<boolean>(false)
  const { mapStyleSetting, setMapStyleSetting } = useMapSettings()
  return (
    <ClickAwayListener onClickAway={() => setShowOpts(false)}>
      <Box zIndex={8} position="relative" rounded="md">
        {showOpts && (
          <Stack gap={4} mb={4} rounded="md">
            <Tooltip label="Color" placement="right">
              <IconButton
                size="md"
                variant="solid"
                bg={mapStyleSetting === "color" ? "blue.500" : "white"}
                _hover={{ bg: mapStyleSetting === "color" ? "blue.500" : "gray.100" }}
                color={mapStyleSetting === "color" ? "white" : "black"}
                aria-label="Change map layer style"
                icon={<HiOutlineColorSwatch />}
                onClick={() => {
                  setMapStyleSetting("color")
                }}
              />
            </Tooltip>

            <Tooltip label="Dark" placement="right">
              <IconButton
                size="md"
                variant="solid"
                bg={mapStyleSetting === "dark" ? "blue.500" : "white"}
                _hover={{ bg: mapStyleSetting === "dark" ? "blue.500" : "gray.100" }}
                color={mapStyleSetting === "dark" ? "white" : "black"}
                aria-label="Change map layer style"
                icon={<MdOutlineDarkMode />}
                onClick={() => {
                  setMapStyleSetting("dark")
                }}
              />
            </Tooltip>

            <Tooltip label="Light" placement="right">
              <IconButton
                size="md"
                variant="solid"
                bg={mapStyleSetting === "light" ? "blue.500" : "white"}
                _hover={{ bg: mapStyleSetting === "light" ? "blue.500" : "gray.100" }}
                color={mapStyleSetting === "light" ? "white" : "black"}
                aria-label="Change map layer style"
                icon={<MdOutlineLightMode size="15px" />}
                onClick={() => {
                  setMapStyleSetting("light")
                }}
              />
            </Tooltip>

            <Tooltip label="Satellite" placement="right">
              <IconButton
                size="md"
                variant="solid"
                bg={mapStyleSetting === "satellite" ? "blue.500" : "white"}
                _hover={{ bg: mapStyleSetting === "satellite" ? "blue.500" : "gray.100" }}
                color={mapStyleSetting === "satellite" ? "white" : "black"}
                aria-label="Change map layer style"
                icon={<LiaSatelliteSolid size="20px" />}
                onClick={() => {
                  setMapStyleSetting("satellite")
                }}
              />
            </Tooltip>
          </Stack>
        )}

        <Box bg="white" rounded="md" shadow="lg">
          <Tooltip label="Map style" placement="right">
            <IconButton
              size="md"
              variant="solid"
              bg={showOpts ? "blue.500" : "white"}
              _hover={{ bg: showOpts ? "blue.500" : "gray.100" }}
              color={showOpts ? "white" : "black"}
              aria-label="Change map layer style"
              icon={<BsLayers />}
              onClick={() => setShowOpts((prev) => !prev)}
            />
          </Tooltip>
        </Box>
      </Box>
    </ClickAwayListener>
  )
}

export default MapStyleControl
